export const isTouch = () => 'touchstart' in window;
